export default __webpack_public_path__ + "static/media/quickstart-fashion.337107e0.png";